import { forwardRef, ReactNode, useImperativeHandle, useRef } from "react";
import { Dialog, DialogClose, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "components/ui/dialog";

type ConfirmDialogRef = {
    close: () => void;
};

type ConfirmDialogProps = {
    handleConfirm: (close: () => void) => void;
    // openConfirm: (callback: () => void) => void;
    trigger: (open: () => void) => ReactNode;
    title: string;
};

const ConfirmDialog = forwardRef<ConfirmDialogRef, ConfirmDialogProps>(({ handleConfirm, title, trigger }, ref) => {
    const triggerRef = useRef<HTMLButtonElement | null>(null);

    const openDialog = () => {
        triggerRef.current?.click();
    };

    useImperativeHandle(ref, () => ({
        close: () => {
            triggerRef.current?.click();
        },
    }));

    return (
        <Dialog>
            {/* 숨은 트리거가 인쇄 시 body 밖으로 벗어나 빈 페이지를 만들지 않도록 relative 로 가둔다 */}
            <div className="relative">
                {trigger(openDialog)}
                <DialogTrigger ref={triggerRef} className="absolute" />
            </div>

            <DialogContent className="bg-white p-0 gap-0">
                <DialogHeader className="border-b border-[#dddddd] p-[32px_40px_20px]">
                    <DialogTitle className="text-[24px]">{title}</DialogTitle>
                    <DialogDescription hidden />
                </DialogHeader>
                <div className="py-[20px] flex flex-col gap-5 items-center">
                    <div className="px-[40px]">
                        <p className="text-[18px]">삭제 하시겠습니까?</p>

                        <div className="flex gap-2 items-center mt-7">
                            <button
                                onClick={() => handleConfirm(() => triggerRef.current?.click())}
                                className="border rounded-lg px-7 py-3 bg-black text-white"
                            >
                                삭제
                            </button>
                            <DialogClose className="border rounded-lg px-7 py-3 bg-[#dddddd]">취소</DialogClose>
                        </div>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
});

export default ConfirmDialog;
